import { IntegrationsService, OrgProfileIntegration, SmtpServer } from '@/api';

const googleOAuthClientId = import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID;
const microsoftOauthClientId = import.meta.env.VITE_MICROSOFT_OAUTH_CLIENT_ID;

export class OauthEmailIntegrationService {
  public async connectGmail(
    orgId: string,
  ): Promise<OrgProfileIntegration | undefined> {
    return new Promise((resolve, reject) => {
      // @TODO: code_challenge << This is very insecure, for now its fine, but this needs to be generated every time we do OAUTH
      const link = `https://accounts.google.com/o/oauth2/v2/auth?scope=openid email profile https://www.googleapis.com/auth/gmail.compose https://www.googleapis.com/auth/gmail.readonly https://www.googleapis.com/auth/gmail.send&access_type=offline&response_type=code&state=rally-dev1 drt:/organization/${orgId}&redirect_uri=${window.location.origin}/gmail_oauth_handler&client_id=${googleOAuthClientId}&include_granted_scopes=true&prompt=consent`;

      const popup = window.open(link, 'popup', 'popup=true');

      if (!popup) {
        alert('Popup blocked. Please allow popups for this website.');
        reject(new Error('Popup blocked'));
        return;
      }

      // @NOTE: This is a bit unsafe implementation
      // @TODO: Implement a secure way to send the token and state back to the main window
      // The commented lines below are a more secure way to send the token and state back to the main window
      // but for some reasons it's not working as expected
      const ef = setInterval(async () => {
        // get the code and state from local storage
        const code = localStorage.getItem('rally_wf_en_gm_code');
        const state = localStorage.getItem('rally_wf_en_gm_state');
        if (code && state) {
          // set into local storage
          localStorage.removeItem('rally_wf_en_gm_code');
          localStorage.removeItem('rally_wf_en_gm_state');
          // remove the interval
          clearInterval(ef);

          try {
            // Step 1. Get the tokens from the code
            const result = await IntegrationsService.getGmailOAuthTokens({
              code: code,
              redirectURI: `${window.location.origin}/gmail_oauth_handler`,
            });

            // Step 2. create a listener for the gmail inbox
            const gmailListenerData =
              await IntegrationsService.createGmailInboxListener({
                accountId: result.userId,
                accessToken: result.accessToken,
                refreshToken: result.refreshToken,
              });
            const historyId = gmailListenerData.historyId;

            // Step 3. Create the integration
            const newOrgProfileIntegration =
              await IntegrationsService.addProfileIntegration(orgId, {
                integrationData: {
                  account_id: result.userId,
                  account_name: result.accountName,
                  email: result.email,
                  expires_at: result.expiresAt || '',
                  id_token: result.idToken,
                  access_token: result.accessToken,
                  refresh_token: result.refreshToken,
                  scopes: result.scopes.split(' '),
                  smtp_server: 'GMAIL' as SmtpServer,
                  grant_type: 'authorization_code',
                  auth_type: 'OAUTH2',
                  last_history_id: historyId,
                  type: 'Gmail',
                },
              });

            resolve(newOrgProfileIntegration.integration);
          } catch (error) {
            reject(error);
          }
        }
      }, 2000);
    });
  }

  public async connectOutlook(
    orgId: string,
  ): Promise<OrgProfileIntegration | undefined> {
    return new Promise((resolve, reject) => {
      // @TODO: code_challenge << This is very insecure, for now its fine, but this needs to be generated every time we do OAUTH
      const link = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${microsoftOauthClientId}&response_type=code&redirect_uri=${window.location.origin}/outlook_oauth_handler&response_mode=query&scope=profile openid offline_access Mail.Read Mail.ReadWrite Mail.Send User.Read&state=rally-dev1 drt:/organization/${orgId}&prompt=consent&code_challenge=V4synebvAOBeyEBs6a4VNh74GNwzslm5j_Zt10pHPkM&code_challenge_method=S256`;

      const popup = window.open(link, 'popup', 'popup=true');

      if (!popup) {
        alert('Popup blocked. Please allow popups for this website.');
        reject(new Error('Popup blocked'));
        return;
      }

      // @NOTE: This is a unsafe implementation
      // @TODO: Implement a secure way to send the token and state back to the main window
      // The commented lines below are a more secure way to send the token and state back to the main window
      // but for some reasons it's not working as expected
      const ef = setInterval(async () => {
        // get the code and state from local storage
        const code = localStorage.getItem('rally_wf_en_ol_code');
        const state = localStorage.getItem('rally_wf_en_ol_state');

        if (code && state) {
          // set into local storage
          localStorage.removeItem('rally_wf_en_ol_code');
          localStorage.removeItem('rally_wf_en_ol_state');
          // remove the interval
          clearInterval(ef);

          try {
            // Step 1. Get the tokens from the code
            const result =
              await IntegrationsService.getMicrosoftOutlookOAuthTokenss({
                code: code,
                redirectURI: `${window.location.origin}/outlook_oauth_handler`,
              });

            // Step 2. create a listener for the outlook inbox
            const outlookListenerData =
              await IntegrationsService.createOutlookInboxListener({
                accountId: result.userId,
                accessToken: result.accessToken,
                refreshToken: result.refreshToken,
              });

            // Step 3. Create the integration
            const newOrgProfileIntegration =
              await IntegrationsService.addProfileIntegration(orgId, {
                integrationData: {
                  account_id: result.userId,
                  account_name: result.accountName,
                  email: result.email,
                  expires_at: result.expiresAt || '',
                  id_token: result.idToken,
                  access_token: result.accessToken,
                  refresh_token: result.refreshToken,
                  scopes: result.scopes.split(' '),
                  smtp_server: 'OUTLOOK' as SmtpServer,
                  grant_type: 'authorization_code',
                  auth_type: 'OAUTH2',
                  inbox_subscription_id: outlookListenerData.subscriptionId,
                  inbox_subscription_expires_at:
                    outlookListenerData.subscriptionExpiryDateTime,
                  type: 'Outlook',
                },
              });
            resolve(newOrgProfileIntegration.integration);
          } catch (error) {
            reject(error);
          }
        }
      }, 2000);
    });
  }
}
